import { useTranslation } from 'react-i18next';
import { Button, Card, Col, RichTextRenderer, Row, Text } from 'ui';
import type { PublicCommunityDataObject } from 'models/service';
import { MembersList } from '../members-list';

type P = {
  community: PublicCommunityDataObject;
  joinCommunity: () => Promise<void>;
};

const PublicCommunityAboutContent = ({ community, joinCommunity }: P) => {
  const { t } = useTranslation();

  return (
    <Row gutter={['ms', 'ms']}>
      <Col span={24}>
        <Button onClick={joinCommunity} size="large" type="primary">
          Join Community
        </Button>
      </Col>

      <Col span={14}>
        <Card
          title={
            <Text size="large" type="title" uppercase>
              {t(String(community.privacy))} {t('group')}
            </Text>
          }
        >
          {community.html_description ? (
            <RichTextRenderer data={community.html_description} />
          ) : (
            <Text>No Results</Text>
          )}
        </Card>
      </Col>

      <Col span={10}>
        <Card title="Contact">
          {community.administrators?.length ? (
            <MembersList members={community.administrators} />
          ) : (
            <Text>No Results</Text>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default PublicCommunityAboutContent;
